export enum EmployeeRole {
  Head = 'HEAD',
  Board = 'BOARD',
  TeamManager = 'TEAM_MANAGER',
  Employee = 'EMPLOYEE',
}
